import { Injectable, inject } from "@angular/core";
import {
  State,
  NgxsAfterBootstrap,
  StateContext,
  Action,
  Store,
} from "@ngxs/store";
import { PROTOCOL_STATE } from "@sdk/lib/values/state-names";
import { SetQuestListInProtocolAction } from "../actions/quest.actions";
import { map, switchMap, tap, filter, take } from "rxjs/operators";
import { ProtocolService } from "@sdk/lib/services/protocol.service";
import {
  OrbitProtocol,
  Protocol,
} from "@sdk/lib/types/protocol";
import { QuestService } from "@sdk/lib/services/quest.service";
import { FetchProtocolListAction } from "../actions/protocol.actions";
import { AuthService } from "@auth0/auth0-angular";

@State<Protocol>({
  name: PROTOCOL_STATE,
  defaults: null,
})
@Injectable({
  providedIn: "root",
})
export class ProtocolState implements NgxsAfterBootstrap {
  private _store = inject(Store);
  private _questService = inject(QuestService);
  private _protocolService = inject(ProtocolService);
  private _auth = inject(AuthService);


  ngxsAfterBootstrap() {
    this._auth.isAuthenticated$.pipe(take(1)).subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this._store.dispatch([new FetchProtocolListAction()]);
      }
    });
  }

  @Action(FetchProtocolListAction)
  fetchProtocolList(stateContext: StateContext<Protocol>) {
    return this._auth.user$.pipe(
      filter((user) => !!user),
      take(1),
      switchMap((user) =>
        this._protocolService.getPatientProtocolByUserID(user.sub)
      ),
      switchMap((patientProtocol) => {
        return this._protocolService.getProtocolListOfGroupCode(
          patientProtocol?.group_code,
        );
      }),
      switchMap((protocol) => {
        const PROTOCOL: any = {
          ...protocol,
        };

        const QUEST_ID_LIST: string[] = [];

        (protocol as OrbitProtocol).protocol_list.forEach((protocolWeek) => {
          protocolWeek.quest_order_list.forEach((questInProtocol) => {
            QUEST_ID_LIST.push(questInProtocol.quest_id);
          });
        });

        return this._questService
          .getQuestsFromQuestObjectID_List(QUEST_ID_LIST)
          .pipe(
            map((questList) => {
              this._store.dispatch(
                new SetQuestListInProtocolAction(questList),
              );

              PROTOCOL.protocol_list = (
                PROTOCOL as OrbitProtocol
              ).protocol_list.map((protocolWeek) => {
                return {
                  ...protocolWeek,
                  quest_order_list: protocolWeek.quest_order_list.map(
                    (protocolQuest) => {
                      return {
                        ...protocolQuest,
                        quest: questList.find(
                          (quest) =>
                            quest._id.toString() === protocolQuest.quest_id,
                        ),
                      };
                    },
                  ),
                };
              });

              return PROTOCOL;
            }),
          );
      }),
      tap((protocol) => {
        stateContext.setState(protocol);
      }),
    );
  }
}
